import { Navigate, RouteObject } from 'react-router-dom';
import { lazy, Suspense } from 'react';
import { RoutePaths } from '@shared/utils/route.utils.ts';
import DigitalSignageDevices from './pages/devices/devices.tsx';
import DeviceScreens from './pages/device-screens/device-screens.tsx';

const DigitalSignageComponent = lazy(() => import('./digital-signage.tsx'));
const PlaylistsComponent = lazy(
  () => import('./pages/playlists/playlists.tsx')
);
const EventsComponent = lazy(() => import('./pages/events/events.tsx'));
const DeviceGroupsComponent = lazy(
  () => import('./pages/device-groups/device-groups.tsx')
);

export const digitalSignageRoutes: RouteObject[] = [
  {
    path: '',
    element: (
      <Suspense>
        <DigitalSignageComponent />
      </Suspense>
    ),
    children: [
      {
        index: true,
        element: (
          <Navigate
            to={RoutePaths.Core.DigitalSignage.Devices.absolutePath}
            replace
          />
        )
      },
      {
        path: RoutePaths.Core.DigitalSignage.Devices.path,
        element: (
          <Suspense>
            <DigitalSignageDevices />
          </Suspense>
        )
      },
      {
        path: RoutePaths.Core.DigitalSignage.Screens.path,
        element: (
          <Suspense>
            <DeviceScreens />
          </Suspense>
        )
      },
      {
        path: RoutePaths.Core.DigitalSignage.Events.path,
        element: (
          <Suspense>
            <EventsComponent />
          </Suspense>
        )
      },
      {
        path: RoutePaths.Core.DigitalSignage.Playlists.path,
        element: (
          <Suspense>
            <PlaylistsComponent />
          </Suspense>
        )
      },
      {
        path: RoutePaths.Core.DigitalSignage.DeviceGroups.path,
        element: (
          <Suspense>
            <DeviceGroupsComponent />
          </Suspense>
        )
      }
    ]
  }
];
